<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { chairTL } from '../../generated/tl';
import { useAuth } from '../../composables/useAuth';
import ChairPickerPanel from './ChairPickerPanel.vue';
import Loader from '../Loader.vue';
import type { ChairListItemDto } from '../../types/chair';

/**
 * Mandatory "pick your acting chair" gate (docs/tasks/022-journal.md část 1) — rendered by
 * App.vue instead of the normal nav+router-view whenever currentChairId is still null. Exactly
 * one chair auto-selects itself (no UI shown at all); more than one (or zero) blocks here until
 * the user picks one — no cancel button, unlike ChairSwitcherDialog.vue's voluntary re-switch.
 */
const { currentUser, setCurrentChair } = useAuth();

const chairs = ref<ChairListItemDto[]>([]);
const loading = ref(true);

onMounted(async () => {
  const all = await chairTL.findChairs();
  chairs.value = all.filter(c => c.user.id === currentUser.value?.id);

  if (chairs.value.length === 1) {
    await setCurrentChair(chairs.value[0].chair.id);
    return;
  }
  loading.value = false;
});
</script>

<template>
  <div class="d-flex justify-content-center mt-5">
    <Loader v-if="loading" />
    <div v-else style="min-width: 20rem;">
      <h4>Vyberte pozici</h4>
      <ChairPickerPanel :chairs="chairs" :current-chair-id="null" @pick="setCurrentChair" />
    </div>
  </div>
</template>
